/** @jsxImportSource react */
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

/** Minimal frame for pages that don't need a tenant (platform administration). */
const StandaloneShell = ({ title, children }) => {
  const navigate = useNavigate()
  const hasTenant = useSelector((state) => !!state.tenant.current)
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="sticky">
        <Toolbar variant="dense" sx={{ gap: 2 }}>
          <Button color="inherit" startIcon={<ArrowBackIcon />} onClick={() => navigate(hasTenant ? '/' : '/select-tenant')}>
            Back
          </Button>
          <Typography variant="subtitle2">{title}</Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: 'auto' }}>{children}</Box>
    </Box>
  )
}

export default StandaloneShell
